export const requiredJobFields = [
  'title',
  'date',
  'url',
  'company',
  'city',
  'state',
  'country',
  'category',
  'description'
];
